import { apiRequest } from "../services/apiRequest"

export const Store = {
  createStore: async (data) => await apiRequest("post", "/api/store/", data),

  // Get Approved Businesses and store

  getApprovedStores: async (data) => {
    const params = new URLSearchParams()

    if (data?.name) params.append("name", data.name)
    if (data?.type) params.append("type", data.type)
    if (data?.status) params.append("status", data.status)
    if (data?.business) params.append("business", data.business)
    if (data?.page) params.append("page", data.page)

    const queryString = params.toString()
    const url = queryString ? `/api/store/?${queryString}` : "/api/store/"

    return await apiRequest("get", url)
  },

  // Get pending and rejected Businesses and store
  getOtherStores: async (data) => {
    const params = new URLSearchParams()

    if (data?.request_status) {
      // Handle single value: 1 for pending or 3 for rejected
      params.append("request_status", data.request_status)
    }
    if (data?.name) params.append("name", data.name)
    if (data?.type) params.append("type", data.type.toUpperCase())
    if (data?.business) params.append("business_id", data.business)
    // Always add request_type for store requests
    if (data?.request_type) {
      params.append("request_type", data.request_type)
    }
    if (data?.page) params.append("page", data.page)
    //      Search for the Busines/Mechants pending and rejected requests
    if (data?.vendor_name) params.append("vendor_name", data.vendor_name)
    if (data?.business_name) params.append("business_name", data.business_name)
    if (data?.ordering) params.append("ordering", data.ordering)
    if (data?.order_by) params.append("order_by", data.order_by)

    const queryString = params.toString()
    const url = `/api/requests/?${queryString}`

    return await apiRequest("get", url)
  },

  getApprovedStoreById: async (data) =>
    await apiRequest("get", `/api/store/${data}`),
  getRejectedStoreById: async (storeId) =>
    await apiRequest("get", `/api/requests/${storeId}/`),
  updateStore: async (data, storeId) =>
    await apiRequest("patch", `/api/store/${storeId}/`, data),
  updateRejectedRequest: async (data, storeId) =>
    await apiRequest(
      `post`,
      `/api/requests/${storeId}/resubmit_request/`,
      data
    ),
  deleteStore: async (storeId) =>
    await apiRequest("delete", `/api/store/${storeId}/`),
  deleteRequest: async (storeId) =>
    await apiRequest("delete", `/api/requests/${storeId}/soft_delete_request/`),

  // Chat apis
  getComments: async (requestId) =>
    await apiRequest("get", `/api/requests/${requestId}/comments/`),
  createComment: async (data, requestId) =>
    await apiRequest("post", `/api/requests/${requestId}/comments/`, data),

  // Approve Request superadmin
  approveRequest: async (requestId, data) => {
    const requestTypeParam = data.request_type
      ? `?request_type=${data.request_type}`
      : ""
    return await apiRequest(
      "post",
      `api/requests/${requestId}/approve_request/${requestTypeParam}`
    )
  }, // Reject Request superadmin
  rejectRequest: async (requestId, data) => {
    const requestTypeParam = data.request_type
      ? `?request_type=${data.request_type}`
      : ""
    return await apiRequest(
      "post",
      `/api/requests/${requestId}/reject_request/${requestTypeParam}`,
      data
    )
  },

  // ✅ Block / Unblock Request superadmin
  blockRequest: async (requestId, data) =>
    await apiRequest(
      "post",
      `/api/requests/${requestId}/blocked_request/`,
      data
    ),

  moveToPending: async (requestId) =>
    await apiRequest(
      "post",
      `/api/requests/${requestId}/move_to_pending/`
    ),

  exportMerchantRequestsCsv: async (data = {}) => {
    const params = new URLSearchParams()
    params.append("export", "csv")

    if (data?.request_status) {
      params.append("request_status", data.request_status)
    }
    if (data?.request_type) {
      params.append("request_type", data.request_type)
    }
    if (data?.vendor_name) {
      params.append("vendor_name", data.vendor_name)
    }
    if (data?.business_name) {
      params.append("business_name", data.business_name)
    }
    if (data?.ordering) {
      params.append("ordering", data.ordering)
    }
    if (data?.order_by) {
      params.append("order_by", data.order_by)
    }

    const queryString = params.toString()
    return await apiRequest("get", `/api/requests/?${queryString}`, undefined, {
      skipCache: true,
      responseType: "blob",
    })
  },

  exportAllRequestsCsv: async (data = {}) => {
    const params = new URLSearchParams()

    if (data?.request_type) {
      params.append("request_type", data.request_type)
    }
    if (data?.vendor_name) {
      params.append("vendor_name", data.vendor_name)
    }
    if (data?.business_name) {
      params.append("business_name", data.business_name)
    }
    if (data?.ordering) {
      params.append("ordering", data.ordering)
    }
    if (data?.order_by) {
      params.append("order_by", data.order_by)
    }

    const queryString = params.toString()
    const url = queryString
      ? `/api/requests/export-csv/?${queryString}`
      : "/api/requests/export-csv/"

    return await apiRequest("get", url, undefined, {
      skipCache: true,
      responseType: "blob",
    })
  },
}
